import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  Show,
  SimpleShowLayout,
  ArrayField,
  SingleFieldList,
  ChipField,
  usePermissions,
  required,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { ArchivalToolbar } from '../components/ArchivalToolbar';
import {
  ArchivedSelect,
  CourseField,
  CourseIdSelect,
  CourseSelect,
} from '../components/selects';
import { useCourseIds } from '../utils/useCourseIds';
import { hasRole, type Permissions } from '../types';
import {
  validateSurveyFieldName,
  validateSurveyFieldType,
} from './surveys-helpers';

const SurveyList = () => {
  const course_ids = useCourseIds();
  const { permissions } = usePermissions<Permissions>();

  return (
    <List
      exporter={false}
      filter={course_ids ? { course_id: course_ids } : undefined}
      sort={{ field: 'name', order: 'ASC' }}
      filters={[
        <CourseIdSelect key="course" alwaysOn />,
        <ArchivedSelect key="archived" />,
      ]}
      perPage={25}
      empty={
        <Box p={3}>
          <Typography>No surveys yet.</Typography>
        </Box>
      }
    >
      <Datagrid
        rowClick={hasRole(permissions, 'tenant_admin') ? 'edit' : 'show'}
      >
        <TextField label="Survey Name" source="name" />
        <CourseField />
      </Datagrid>
    </List>
  );
};

const SurveyShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="Survey Name" source="name" />
      <CourseField />
      <ArrayField label="Fields" source="fields">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);

const SurveyCreate = () => (
  <Create>
    <SurveyForm />
  </Create>
);

const SurveyEdit = () => (
  <Edit mutationMode="pessimistic">
    <SurveyForm />
  </Edit>
);

const SurveyForm = () => (
  <SimpleForm toolbar={<ArchivalToolbar />} warnWhenUnsavedChanges>
    <TextInput label="Survey Name" fullWidth source="name" validate={required()} />
    <CourseSelect />
    <ArrayInput source="fields">
      <SimpleFormIterator>
        <TextInput fullWidth label="Name" source="name" validate={validateSurveyFieldName} />
        <SelectInput
          fullWidth
          source="type"
          label="Field Type"
          defaultValue="text"
          validate={validateSurveyFieldType}
          choices={[
            { id: 'text', name: 'Text' },
            { id: 'number', name: 'Number' },
            { id: 'date', name: 'Date' },
          ]}
        />
      </SimpleFormIterator>
    </ArrayInput>
  </SimpleForm>
);

export const surveys = {
  list: SurveyList,
  show: SurveyShow,
  create: SurveyCreate,
  edit: SurveyEdit,
};
